export default {"src":"/_next/static/media/arrow-right-outline.bea3d650.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};